import { render, staticRenderFns } from "./FrotaSettingsList.vue?vue&type=template&id=2d260e18"
import script from "./FrotaSettingsList.vue?vue&type=script&lang=js"
export * from "./FrotaSettingsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports